import React, { useEffect, useRef } from "react"
import { useStaticQuery, graphql } from "gatsby"

import styled from "styled-components"
import useWindowDimensions from "../../../components/useWindowDimensions"

import { gsap } from "gsap"
// import { GSDevTools } from "gsap/dist/GSDevTools"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"
// import { MotionPathHelper } from "gsap/MotionPathHelper"
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin"

const Wrapper = styled.div`
  .hero-splat {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media (max-width: 900px) {
      svg {
        width: 450px;
        height: 450px;
      }
    }
    @media (max-width: 640px) {
      svg {
        width: 420px;
        height: 360px;
      }
    }
  }

  .hero-cup-image {
    position: relative;
    z-index: 10;
    opacity: 0;
  }

  .hero-flair-image {
    &-1,
    &-2 {
      position: absolute;
      z-index: 2;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;

      @media (max-width: 900px) {
        height: 80px;
      }
      @media (max-width: 640px) {
        width: 80px;
        height: auto;
      }
    }

    &-3 {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 35%;
      opacity: 0;

      @media (max-width: 900px) {
        width: 110px;
      }
    }
  }
`

export default function Milkshake(props) {
  let splatCircleRef = useRef(null)
  let splatPathRef = useRef(null)
  let cupImgRef = useRef(null)
  let flairImg1Ref = useRef(null)
  let flairImg2Ref = useRef(null)
  let flairImg3Ref = useRef(null)

  const { width } = useWindowDimensions()

  const splashTimeline = useRef(null)

  const milkshakeImages = useStaticQuery(graphql`
    query CupSplashmilkshakeImages {
      heroCup: file(relativePath: { eq: "milkshake/hero-cup.png" }) {
        childImageSharp {
          fluid(maxWidth: 376) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair1: file(relativePath: { eq: "milkshake/flair-01.png" }) {
        childImageSharp {
          fluid(maxWidth: 127) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      flair2: file(relativePath: { eq: "milkshake/flair-02.png" }) {
        childImageSharp {
          fluid(maxWidth: 134) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mintLeaf: file(relativePath: { eq: "milkshake/mint-leaf.png" }) {
        childImageSharp {
          fluid(maxWidth: 169) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const createTimeline = () => {
    gsap.set(splatCircleRef, {
      opacity: 0,
    })

    gsap.set(cupImgRef, {
      opacity: 0,
      scale: 0.3,
      rotate: 35,
    })

    gsap.set(flairImg1Ref, {
      scale: 0,
      xPercent: -50,
      yPercent: -50,
    })
    gsap.set(flairImg2Ref, {
      scale: 0,
      xPercent: -50,
      yPercent: -50,
    })

    gsap.set(flairImg3Ref, {
      scale: 0.2,
      opacity: 0,
      rotate: 45,
      xPercent: -50,
      yPercent: 0,
      transformOrigin: "90% 95%",
    })

    splashTimeline.current = gsap.timeline({ paused: true })

    // SPLAT!
    splashTimeline.current.to(splatCircleRef, 1.4, {
      opacity: 1,
      morphSVG: {
        shape: splatPathRef,
        type: "rotational",
        shapeIndex: [-19, 0, 0, 0],
        precompile: [
          "M389.15349,303.03164 C392.40837,303.69769 395.60564,304.52187 398.73694,305.4958 401.86824,306.46974 404.93355,307.59343 407.92451,308.8585 410.91547,310.12356 413.83207,311.53001 416.66594,313.06946 419.4998,314.60891 422.25093,316.28136 424.91095,318.07843 427.57097,319.8755 430.13987,321.7972 432.60929,323.83514 435.0787,325.87308 437.44862,328.02727 439.71068,330.28932 441.97273,332.55138 444.12692,334.9213 446.16486,337.39071 448.2028,339.86013 450.1245,342.42903 451.92157,345.08905 453.71864,347.74907 455.39109,350.5002 456.93054,353.33406 458.46999,356.16793 459.87644,359.08453 461.1415,362.07549 462.40657,365.06645 463.53026,368.13176 464.5042,371.26306 465.47813,374.39436 466.30231,377.59163 466.96836,380.84651 467.6344,384.10139 468.14231,387.41387 468.48371,390.77558 468.82511,394.13729 469,397.54822 469,401 469,404.24873 468.84508,407.46128 468.54223,410.63067 468.23938,413.80005 467.78859,416.92627 467.19685,420.00233 466.60511,423.07839 465.87243,426.1043 465.00577,429.07308 464.13912,432.04185 463.1385,434.95349 462.0109,437.80101 460.8833,440.64852 459.62872,443.43192 458.25415,446.14421 456.87957,448.8565 455.385,451.49769 453.77741,454.06078 452.16983,456.62388 450.44923,459.10888 448.6226,461.50881 446.79598,463.90874 444.86333,466.2236 442.83163,468.4464 440.79994,470.6692 438.6692,472.79994 436.4464,474.83163 434.2236,476.86333 431.90874,478.79598 429.50881,480.6226 427.10888,482.44923 424.62388,484.16983 422.06078,485.77741 419.49769,487.385 416.8565,488.87957 414.14421,490.25415 411.43192,491.62872 408.64852,492.8833 405.80101,494.0109 402.95349,495.1385 400.04185,496.13912 397.07308,497.00577 394.1043,497.87243 391.07839,498.60511 388.00233,499.19685 384.92627,499.78859 381.80005,500.23938 378.63067,500.54223 375.46128,500.84508 372.24873,501 369,501 365.54822,501 362.13729,500.82511 358.77558,500.48371 355.41387,500.14231 352.10139,499.6344 348.84651,498.96836 345.59163,498.30231 342.39436,497.47813 339.26306,496.5042 336.13176,495.53026 333.06645,494.40657 330.07549,493.1415 327.08453,491.87644 324.16793,490.46999 321.33406,488.93054 318.5002,487.39109 315.74907,485.71864 313.08905,483.92157 310.42903,482.1245 307.86013,480.2028 305.39071,478.16486 302.9213,476.12692 300.55138,473.97273 298.28932,471.71068 296.02727,469.44862 293.87308,467.0787 291.83514,464.60929 289.7972,462.13987 287.8755,459.57097 286.07843,456.91095 284.28136,454.25093 282.60891,451.4998 281.06946,448.66594 279.53001,445.83207 278.12356,442.91547 276.8585,439.92451 275.59343,436.93355 274.46974,433.86824 273.4958,430.73694 272.52187,427.60564 271.69769,424.40837 271.03164,421.15349 270.3656,417.89861 269.85769,414.58613 269.51629,411.22442 269.17489,407.86271 269,404.45178 269,401 269,397.75127 269.15492,394.53872 269.45777,391.36933 269.76062,388.19995 270.21141,385.07373 270.80315,381.99767 271.39489,378.92161 272.12757,375.8957 272.99423,372.92692 273.86088,369.95815 274.8615,367.04651 275.9891,364.19899 277.1167,361.35148 278.37128,358.56808 279.74585,355.85579 281.12043,353.1435 282.615,350.50231 284.22259,347.93922 285.83017,345.37612 287.55077,342.89112 289.3774,340.49119 291.20402,338.09126 293.13667,335.7764 295.16837,333.5536 297.20006,331.3308 299.3308,329.20006 301.5536,327.16837 303.7764,325.13667 306.09126,323.20402 308.49119,321.3774 310.89112,319.55077 313.37612,317.83017 315.93922,316.22259 318.50231,314.615 321.1435,313.12043 323.85579,311.74585 326.56808,310.37128 329.35148,309.1167 332.19899,307.9891 335.04651,306.8615 337.95815,305.86088 340.92692,304.99423 343.8957,304.12757 346.92161,303.39489 349.99767,302.80315 353.07373,302.21141 356.19995,301.76062 359.36933,301.45777 362.53872,301.15492 365.75127,301 369,301 372.45178,301 375.86271,301.17489 379.22442,301.51629 382.58613,301.85769 385.89861,302.3656 389.15349,303.03164 zM465.00577,429.07308 C465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 465.00577,429.07308 M269.51629,411.22442 C269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 269.51629,411.22442 M301.5536,327.16837 C301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 301.5536,327.16837 ",
          "M439.1,3.2161 C443.3522,1.336 448.1109,0.8156 452.768,0.9298 458.2065,1.06409 463.737,2.0814 468.427,4.7974 476.0409,9.2089 480.575,17.6964 481.874,26.3174 483.1724,34.9423 481.61227,43.7384 479.3655,52.1684 467.5635,96.4344 436.7545,137.7694 454.6375,184.6984 464.8895,211.5974 488.3935,235.3034 518.7645,242.4204 528.0779,244.6026 537.7415,245.217 547.3505,245.5863 569.8015,246.45248 593.5135,245.76088 612.8135,235.3193 639.5675,220.8493 651.1955,191.6743 671.1035,169.9393 680.6277,159.5413 695.8795,150.1283 709.5235,155.5563 718.9219,159.2997 723.8775,169.3113 723.4015,178.6113 722.92563,187.9144 717.9936,196.5563 712.1985,204.2413 699.0105,221.7433 680.7125,236.0453 659.6895,245.2943 631.4875,257.7033 596.1335,259.1163 575.6785,280.6603 557.6265,299.6723 554.8725,329.3753 569.1693,350.8553 576.5283,361.9113 587.6363,370.5663 595.2643,381.4703 602.8918,392.3753 606.3793,407.5263 597.6674,417.7363 593.8537,422.2082 588.0752,425.26 585.1624,430.2553 579.5234,439.9344 586.9265,451.5943 586.3351,462.5293 585.66548,474.9683 574.5881,485.0403 562.5141,490.9723 550.4441,496.9047 536.8651,500.0001 524.8861,506.0833 493.3801,522.0873 477.8911,557.0233 479.0731,589.7673 480.9222,641.0973 512.9071,676.6843 539.9131,716.9973 546.4121,726.6999 552.5411,736.9933 554.7161,748.4253 556.8949,759.8573 554.45777,772.7453 545.8751,780.7123 536.198,789.6965 520.0731,790.2168 509.0291,782.9315 489.3111,769.9255 492.5331,738.8435 488.6691,718.4145 483.5909,691.5565 476.9901,664.8155 465.6571,639.7935 458.859,624.7865 449.9601,609.9475 435.8001,600.0365 421.6401,590.1257 401.1841,586.2315 385.5721,594.1478 373.8451,600.0902 366.8261,611.2738 358.7131,620.9898 350.6029,630.7058 339.0831,640.0118 325.6881,639.1228 311.4121,638.1794 301.1371,625.8918 296.7011,613.5468 292.2651,601.2018 291.6263,587.8468 286.1951,575.8338 280.7634,563.8178 269.1351,552.8798 254.8391,553.4438 232.2221,554.33684 209.3561,563.0155 195.5461,579.2948 185.5733,591.0518 180.8891,605.7878 172.1841,618.3468 163.4757,630.9028 147.8671,641.8348 131.9561,638.4138 113.0981,634.3582 105.6231,611.5958 112.9821,595.3298 120.3411,579.0638 137.4381,568.3568 154.1961,559.5238 164.5121,554.085 175.2671,548.8338 183.2041,540.7468 202.5551,521.0328 197.8951,486.6708 174.839,470.5658 162.592,462.0114 147.075,458.4428 133.411,451.8858 122.106,446.457 111.83,438.7018 105.763,428.4858 99.6957,418.2728 98.3327,405.4108 104.0567,395.0338 113.7406,377.4788 139.1387,372.1638 152.5137,356.7268 165.8757,341.3138 163.2067,316.4828 146.8169,303.6948 113.9679,278.0688 63.1289,296.0401 25.2469,292.6088 18.4012,291.99106 11.1579,290.5776 6.2329,285.8438 2.8304,282.5704 0.9134,277.9944 0.2641,273.3448 -1.7311,259.0128 8.3029,244.8048 21.6101,238.7608 34.9171,232.7176 50.5871,233.6946 64.5371,238.10277 78.4871,242.51094 91.1411,250.08877 103.8911,257.20577 134.9791,274.55977 160.5021,276.05677 195.4041,269.78577 210.5641,267.05967 212.3551,267.05967 227.8821,262.46227 231.198,261.48046 252.4651,248.45127 254.8391,245.58627 265.3951,232.84927 272.1211,214.80627 261.346,196.65327 250.992,179.20527 228.103,169.52327 212.355,157.35227 200.241,147.99207 191.689,131.18227 200.822,119.36727 209.5916,108.02327 229.687,109.13127 241.658,117.72557 253.234,126.03377 259.302,138.90657 265.395,151.14957 276.683,172.04257 285.539,187.25157 291.961,196.77657 319.391,237.45657 369.837,207.98657 394.591,180.06757 429.812,140.34057 410.237,79.74757 420.536,32.09757 423.0377,20.50857 428.1601,8.06257 439.108,3.21757 439.10545,3.21691 439.10289,3.21626 439.10034,3.2156 zM638.14,433.7461 C644.2268,436.1279 649.195,441.2696 651.415,447.4741 654.4769,456.0403 653.5472,463.8501 660.0686,470.5971 670.4336,481.3201 687.4406,505.5161 667.9272,517.7181 663.6358,520.3997 658.2125,520.427 653.2402,519.5683 649.0801,518.84594 644.8426,517.4659 641.8652,514.4402 635.4146,507.8946 637.375,497.1712 637.6849,487.9342 638.05543,477.0272 635.3775,466.0282 630.0418,456.5422 628.014,452.9372 625.5786,449.4685 624.5411,445.4542 623.507,441.4403 624.25478,436.578 627.5929,434.1652 630.5775,432.0049 634.7173,432.4036 638.1399,433.7461 zM65.14,436.9322 C67.5889,448.4372 51.873,452.2972 38.752,455.0822 25.631,457.8671 14.421,457.43 11.972,445.9255 9.5231,434.4205 18.1746,422.8375 31.296,420.0525 44.416,417.2673 62.691,425.4279 65.14,436.9325 zM213.59,211.7222 C220.3274,212.7233 224.822,215.836 220.6668,224.0842 217.7889,229.7971 208.4398,235.9472 202.7038,238.1752 195.2544,241.0624 187.2528,244.076 179.5108,240.3859 170.0851,235.8928 162.7758,219.8719 174.2739,213.1029 184.222,207.2462 202.8209,210.1232 213.5899,211.7222 z",
        ],
      },
      ease: "power3.out",
    })

    splashTimeline.current.addLabel("cup-enter", "-=0.8")

    splashTimeline.current.to(
      cupImgRef,
      2.6,
      {
        scale: 1,
        rotate: 0,
        opacity: 1,
        ease: "elastic.out(1, 0.5)",
      },
      "cup-enter"
    )

    const flair1pathLarge =
      "M-25.942,-2.898 C-52.85,-77.911 -130.268,-82.663 -188.493,-76.023 -246.743,-69.344 -296.025,-9.279 -303.124,82.587 "
    const flair1pathSmall =
      "M-43.383,6.496 C-59.549,-41.053 -143.221,-66.915 -170.471,-46.332 -194.012,-28.55 -232.702,5.751 -218.541,58.941 "
    let flair1path = flair1pathLarge
    if (width <= 900) {
      flair1path = flair1pathSmall
    }

    splashTimeline.current.to(
      flairImg1Ref,
      1.6,
      {
        scale: 1,
        opacity: 1,
        motionPath: {
          path: flair1path,
          align: "self",
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
        },
      },
      "cup-enter"
    )
    // MotionPathHelper.create(flairImg1Ref)

    const flair2pathLarge =
      "M-14.942,46.995 C-15.383,-42.741 49.2,-81.268 86.857,-100.628 141.272,-128.592 206.055,-69.458 228.472,20.155 "
    const flair2pathSmall =
      "M-55.996,52.619 C-30.742,33.362 -8.195,31.143 18.067,40.317 67.758,57.675 98.579,106.739 88.163,153.792 "
    const flair2pathSmaller =
      "M-86.792,38.943 C-75.154,26.049 -40.231,24.773 -19.21,35.569 27.604,59.611 14.223,134.462 -32.888,160.005 "
    let flair2path = flair2pathLarge
    if (width <= 900 && width > 640) {
      flair2path = flair2pathSmall
    } else if (width <= 640) {
      flair2path = flair2pathSmaller
    }
    splashTimeline.current.to(
      flairImg2Ref,
      1.2,
      {
        scale: 1,
        opacity: 1,
        motionPath: {
          path: flair2path,
          align: "self",
          autoRotate: true,
          alignOrigin: [0.5, 0.5],
        },
      },
      "cup-enter"
    )
    // MotionPathHelper.create(flairImg2Ref)

    splashTimeline.current.to(
      flairImg3Ref,
      0.7,
      {
        scale: 1,
        rotate: 0,
        opacity: 1,
      },
      "-=1.5"
    )
  }

  useEffect(() => {
    gsap.registerPlugin(
      // GSDevTools,
      MotionPathPlugin,
      // MotionPathHelper,
      MorphSVGPlugin
    )

    createTimeline()

    const timer = setTimeout(() => {
      splashTimeline.current.play()
    }, 200)

    // if (false) {
    //   if (GSDevTools.getById("main")) {
    //     GSDevTools.getById("main").kill()
    //   }

    //   GSDevTools.create({
    //     id: "main",
    //     animation: splashTimeline,
    //     // paused: true,
    //   })
    // }

    return () => {
      clearTimeout(timer)
      // splashTimeline.kill()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Wrapper>
      <div className={`hero-splat`}>
        <svg
          width="739px"
          height="788px"
          viewBox="0 0 724 788"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          // xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g>
            <path
              className="splat-from"
              style={{ opacity: 0 }}
              fill="#FEFEFE"
              d="M269,401a100,100 0 1,0 200,0a100,100 0 1,0 -200,0"
              ref={el => {
                splatCircleRef = el
              }}
            />
            <path
              className="splat-to"
              style={{
                visibility: "hidden",
              }}
              fill="#FEFEFE"
              d="m439.1 3.2161c4.2522-1.8801 9.0109-2.4005 13.668-2.2863 5.4385 0.13429 10.969 1.1516 15.659 3.8676 7.6139 4.4115 12.148 12.899 13.447 21.52 1.2984 8.6249-0.26173 17.421-2.5085 25.851-11.802 44.266-42.611 85.601-24.728 132.53 10.252 26.899 33.756 50.605 64.127 57.722 9.3134 2.1822 18.977 2.7966 28.586 3.1659 22.451 0.86618 46.163 0.17458 65.463-10.267 26.754-14.47 38.382-43.645 58.29-65.38 9.5242-10.398 24.776-19.811 38.42-14.383 9.3984 3.7434 14.354 13.755 13.878 23.055-0.47587 9.3031-5.4079 17.945-11.203 25.63-13.188 17.502-31.486 31.804-52.509 41.053-28.202 12.409-63.556 13.822-84.011 35.366-18.052 19.012-20.806 48.715-6.5092 70.195 7.359 11.056 18.467 19.711 26.095 30.615 7.6275 10.905 11.115 26.056 2.4031 36.266-3.8137 4.4719-9.5922 7.5237-12.505 12.519-5.639 9.6791 1.7641 21.339 1.1727 32.274-0.66962 12.439-11.747 22.511-23.821 28.443-12.07 5.9324-25.649 9.0278-37.628 15.111-31.506 16.004-46.995 50.94-45.813 83.684 1.8491 51.33 33.834 86.917 60.84 127.23 6.499 9.7026 12.628 19.996 14.803 31.428 2.1788 11.432-0.25833 24.32-8.841 32.287-9.6771 8.9842-25.802 9.5045-36.846 2.2192-19.718-13.006-16.496-44.088-20.36-64.517-5.0782-26.858-11.679-53.599-23.012-78.621-6.7981-15.007-15.697-29.846-29.857-39.757-14.16-9.9108-34.616-13.805-50.228-5.8887-11.727 5.9424-18.746 17.126-26.859 26.842-8.1102 9.716-19.63 19.022-33.025 18.133-14.276-0.9434-24.551-13.231-28.987-25.576s-5.0748-25.7-10.506-37.713c-5.4317-12.016-17.06-22.954-31.356-22.39-22.617 0.89304-45.483 9.5717-59.293 25.851-9.9728 11.757-14.657 26.493-23.362 39.052-8.7084 12.556-24.317 23.488-40.228 20.067-18.858-4.0556-26.333-26.818-18.974-43.084s24.456-26.973 41.214-35.806c10.316-5.4388 21.071-10.69 29.008-18.777 19.351-19.714 14.691-54.076-8.3651-70.181-12.247-8.5544-27.764-12.123-41.428-18.68-11.305-5.4288-21.581-13.184-27.648-23.4-6.0673-10.213-7.4303-23.075-1.7063-33.452 9.6839-17.555 35.082-22.87 48.457-38.307 13.362-15.413 10.693-40.244-5.6968-53.032-32.849-25.626-83.688-7.6547-121.57-11.086-6.8457-0.61774-14.089-2.0312-19.014-6.765-3.4025-3.2734-5.3195-7.8494-5.9688-12.499-1.9952-14.332 8.0388-28.54 21.346-34.584 13.307-6.0432 28.977-5.0662 42.927-0.65803s26.604 11.986 39.354 19.103c31.088 17.354 56.611 18.851 91.513 12.58 15.16-2.7261 16.951-2.7261 32.478-7.3235 3.3159-0.98181 24.583-14.011 26.957-16.876 10.556-12.737 17.282-30.78 6.5069-48.933-10.354-17.448-33.243-27.13-48.991-39.301-12.114-9.3602-20.666-26.17-11.533-37.985 8.7696-11.344 28.865-10.236 40.836-1.6417 11.576 8.3082 17.644 21.181 23.737 33.424 11.288 20.893 20.144 36.102 26.566 45.627 27.43 40.68 77.876 11.21 102.63-16.709 35.221-39.727 15.646-100.32 25.945-147.97 2.5017-11.589 7.6241-24.035 18.572-28.88l-0.00766-0.00197zm199.04 430.53c6.0868 2.3818 11.055 7.5235 13.275 13.728 3.0619 8.5662 2.1322 16.376 8.6536 23.123 10.365 10.723 27.372 34.919 7.8586 47.121-4.2914 2.6816-9.7147 2.7089-14.687 1.8502-4.1601-0.72236-8.3976-2.1024-11.375-5.1281-6.4506-6.5456-4.4902-17.269-4.1803-26.506 0.37053-10.907-2.3074-21.906-7.6431-31.392-2.0278-3.605-4.4632-7.0737-5.5007-11.088-1.0341-4.0139-0.28632-8.8762 3.0518-11.289 2.9846-2.1603 7.1244-1.7616 10.547-0.4191zm-573 3.1861c2.4489 11.505-13.267 15.365-26.388 18.15-13.121 2.7849-24.331 2.3478-26.78-9.1567-2.4489-11.505 6.2026-23.088 19.324-25.873 13.12-2.7852 31.395 5.3754 33.844 16.88zm148.45-225.21c6.7374 1.0011 11.232 4.1138 7.0768 12.362-2.8779 5.7129-12.227 11.863-17.963 14.091-7.4494 2.8872-15.451 5.9008-23.193 2.2107-9.4257-4.4931-16.735-20.514-5.2369-27.283 9.9481-5.8567 28.547-2.9797 39.316-1.3807z"
              ref={el => {
                splatPathRef = el
              }}
            ></path>
          </g>
        </svg>
      </div>

      <div
        ref={el => {
          cupImgRef = el
        }}
        className={`hero-cup-image`}
      >
        <img
          alt="Milkshake!"
          src={milkshakeImages.heroCup.childImageSharp.fluid.src}
        />
      </div>

      <div
        ref={el => {
          flairImg1Ref = el
        }}
        className={`hero-flair-image-1`}
      >
        <img
          alt="Do you have enough flair?"
          src={milkshakeImages.flair1.childImageSharp.fluid.src}
        />
      </div>

      <div
        ref={el => {
          flairImg2Ref = el
        }}
        className={`hero-flair-image-2`}
      >
        <img
          alt="You can never have enough flair!"
          src={milkshakeImages.flair2.childImageSharp.fluid.src}
        />
      </div>

      <div
        ref={el => {
          flairImg3Ref = el
        }}
        className={`hero-flair-image-3`}
      >
        <img
          alt="More flair, more!"
          src={milkshakeImages.mintLeaf.childImageSharp.fluid.src}
        />
      </div>
    </Wrapper>
  )
}
